import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"

export const getDaysOfWeek = atom<string[] | []>({
	key: ATOMS_KEYS.GETDAYSOFWEEK,
	default: [],
})
